import { Injectable } from '@angular/core';
import { ApplicationInsights, SeverityLevel } from '@microsoft/applicationinsights-web'
import { environment } from '@environment';
@Injectable()
export class SxApplicationInsightsService  {

  appInsights: ApplicationInsights;
  isInitialized = false;

  initService(instrumentationKey: string) {
    if (!instrumentationKey) {
      return;
    }
    this.appInsights = new ApplicationInsights({
      config: {
        instrumentationKey: instrumentationKey,
      }
    });
    this.appInsights.loadAppInsights();
    this.isInitialized = true;
  }

  setAuthenticatedUserId(userId: string): void {
    this.appInsights.setAuthenticatedUserContext(userId);
  }

  public logPageView(
    name: string,
    url?: string,
    properties?: { [key: string]: string },
    measurements?: { [key: string]: number },
    duration?: number
    ) {

    if (!this.isInitialized) {
      if (!environment.production) {
        console.warn('SxApplicationInsightsService is not initialized. Call initService() with key before using this service.');
      }
      return;
    }
  
    if (url && url.length > 1000) {
      url = url.substring(0, 1000);
    }

    if (!properties) {
      properties = {};
    }

   // console.log(`sxApplicationInsightsService\tPageView logged ${name}`, url);
   if (duration) {
    properties['duration'] = duration.toString();
   }

   this.appInsights.trackPageView({
    name: name,
    uri: url,
    properties: properties,
    measurements: measurements
   });
  }

  public logEvent(name: string, properties?: { [key: string]: string }, measurements?: { [key: string]: number }) {
    if (!this.isInitialized) {
      if (!environment.production) {
        console.warn('SxApplicationInsightsService is not initialized. Call initService() with key before using this service.');
      }
      return;
    }

    if (!properties) {
      properties = {};
    }
    if (!measurements) {
      measurements = {};
    }

    this.appInsights.trackEvent({
      name: name,
      properties: properties,
      measurements: measurements
    });
  }

  public logTrace(name: string, properties?: { [key: string]: string }, severityLevel?: SeverityLevel) {
    if (!this.isInitialized) {
      if (!environment.production) {
        console.warn('SxApplicationInsightsService is not initialized. Call initService() with key before using this service.');
      }
      return;
    }

    if (!properties) {
      properties = {};
    }
    this.appInsights.trackTrace({
      message: name,
      properties: properties,
      severityLevel: severityLevel
    });
  }

  public logException(err: Error,
    handledAt?: string,
    properties?: { [key: string]: string },
    measurements?: { [key: string]: number },
    severityLevel?: SeverityLevel) {
    if (!this.isInitialized) {
      if (!environment.production) {
        console.warn('SxApplicationInsightsService is not initialized. Call initService() with key before using this service.');
      }
      return;
    }
    
    if (!properties) {
      properties = {};
    }

    this.appInsights.trackException({
      error: err,
      properties: properties,
      measurements: measurements,
      severityLevel: severityLevel
    });
  }
}
